import config from "config";
import { currentTokenVar, isLoggedInVar } from "./auth";

const REFRESH_BUFFER_MS = 5 * 60 * 1000;
let refreshTimer: ReturnType<typeof setTimeout> | undefined;

function apiBaseUrl(): string {
  return config.apollo.uri.replace(/\/graphql\/?$/, "");
}

function authHeaders(): HeadersInit {
  const token = currentTokenVar();
  return {
    ...(token ? { authorization: token } : {}),
    "subs-client": config.name,
  };
}

function scheduleRefresh(expiresAt: number) {
  if (refreshTimer) clearTimeout(refreshTimer);
  const delay = Math.max(expiresAt - Date.now() - REFRESH_BUFFER_MS, 30_000);
  refreshTimer = setTimeout(() => {
    void ensureCdnSession();
  }, delay);
}

export async function ensureCdnSession(): Promise<void> {
  if (!isLoggedInVar() || !currentTokenVar()) return;

  try {
    const response = await fetch(`${apiBaseUrl()}/api/cdn/cookies`, {
      method: "POST",
      headers: authHeaders(),
      credentials: "include",
    });
    if (!response.ok) {
      throw new Error(`CDN cookie mint failed (${response.status})`);
    }
    const data = await response.json();
    if (data?.expiresAt) {
      scheduleRefresh(data.expiresAt);
    }
  } catch (err) {
    // CDN may be unset in local/dev; fail soft so login still works.
    console.warn("Failed to mint CloudFront cookies", err);
  }
}

export async function clearCdnSession(): Promise<void> {
  if (refreshTimer) {
    clearTimeout(refreshTimer);
    refreshTimer = undefined;
  }
  const token = currentTokenVar();
  if (!token) return;
  try {
    await fetch(`${apiBaseUrl()}/api/cdn/cookies`, {
      method: "DELETE",
      headers: authHeaders(),
      credentials: "include",
    });
  } catch (err) {
    console.warn("Failed to clear CloudFront cookies", err);
  }
}
